<!-- Copyright © 2026 Xerox Corporation. All Rights Reserved. Copyright protection claimed includes all forms and matters of copyrightable material and information now allowed by statutory or judicial law or hereinafter granted, including without limitation, material generated from the software programs which are displayed on the screen such as icons, screen display looks, etc. -->
@if (!isPrint) {
<div>
  @switch (setting.type) {
  <!-- TODO add more control for unhandled setting types -->
  @case (SettingType.Message) {
  <xrx-message [label]="setting.label"
               [message]="setting.placeholder"></xrx-message>
  }
  @case (SettingType.SelectConversion) {
  <xrx-select-conversion [label]="setting.label"
                         [label2]="setting.label2 || ''"
                         [inlineLabel]="setting.placeholder"
                         [inlineLabel2]="setting.placeholder2 || ''"
                         [list]="setting.options"
                         [list2]="setting.options2"
                         localize="key"
                         property="value"
                         orderby="key"
                         [(selectedItem)]="setting.selectedValue"
                         [(selectedItem2)]="setting.selectedValue2"
                         (change)="setting.value = $event.value"
                         (change2)="setting.value2 = $event.value"
                         (validation)="validate($event)"
                         [required]="setting.required"
                         [description]="setting.description || ''"
                         [error]="setting.error || ''">
  </xrx-select-conversion>
  }
  @case (SettingType.Select) {
  <xrx-select [label]="setting.label"
              [inlineLabel]="setting.placeholder"
              [list]="setting.options"
              [localize]="'key'"
              [property]="'value'"
              [orderby]="'key'"
              [(selectedItem)]="setting.selectedValue"
              (change)="setting.value = $event.value; relayChange($event)"
              [required]="setting.required"
              [isInputOnly]="true"
              (validation)="validate($event)"
              [error]="setting.error || ''">
  </xrx-select>
  }
  @case (SettingType.SelectWithGroup) {
  <xrx-select type="group"
              [label]="setting.label"
              [inlineLabel]="setting.placeholder"
              [list]="setting.options"
              [localize]="'key'"
              [property]="'value'"
              [orderby]="'key'"
              [(selectedItem)]="setting.selectedValue"
              (change)="setting.value = $event.value; relayChange($event)"
              [required]="setting.required"
              [isInputOnly]="true"
              [error]="setting.error || ''">
  </xrx-select>
  }
  @case (SettingType.MultiSelect) {
  <xrx-multi-select type="group"
                    [setting]="setting"
                    [list]="setting.options"
                    [localize]="'key'"
                    (change)="
                    setting.value = $event.value.toString();
                    relayMultiSelectChange($event)"
                    [required]="setting.required"
                    [leftAlignText]="true"
                    [isBordered]="true"
                    [hasScrollbar]="true"
                    [maximumItemsSelected]="5"
                    (validation)="validate($event)">
  </xrx-multi-select>
  }
  @case (SettingType.MultiTranslation) {
  <xrx-multi-translation [setting]="setting"
                         [label]="setting.label"
                         [label2]="setting.label2 || ''"
                         [inlineLabel]="setting.placeholder || ''"
                         [inlineLabel2]="setting.placeholder2 || ''"
                         [list]="setting.options"
                         [list2]="setting.options2"
                         localize="key"
                         property="value"
                         orderby="key"
                         [(selectedItem)]="setting.selectedValue"
                         [(selectedItem2)]="setting.selectedValue2"
                         (change)="setting.value = $event.value"
                         (change2)="setting.value2 = $event.value"
                         (validation)="validate($event)"
                         [required]="setting.required">
  </xrx-multi-translation>
  }
  @case (SettingType.NumberCount) {
  <xrx-incrementer [label]="setting.label"
                   [initialValue]="setting.value ? +setting.value : 0"
                   [maxLength]="setting.maxlength || 100"
                   [icon]="setting.icon"
                   [isMfd]="false"
                   (valueChange)="relayChange($event)">
  </xrx-incrementer>
  }
  @case (SettingType.Toggle) {
  <xrx-toggle-switch [label]="setting.label"
                     [switchOn]="setting.value?.toLowerCase() == 'true'"
                     [glyph]="setting.glyph"
                     (toggle)="relayToggle($event)">
  </xrx-toggle-switch>
  }
  @case (SettingType.Redact) {
  <xrx-redact [label]="setting.label"
              [value]="setting.value || ''"
              [value2]="setting.value2 || ''"
              (change)="setting.value = $event"
              (change2)="setting.value2 = $event"
              (validation)="validate($event)"
              [isAutomated]="isAutomated">
  </xrx-redact>
  }
  @case (SettingType.XmFax) {
  <xrx-xmfax [label]="setting.label"
             [isMfd]="false"
             [value]="setting.value || ''"
             [countryCodes]="setting.options"
             (change)="setting.value = $event"
             (validation)="validate($event)">
  </xrx-xmfax>
  }
  @case (SettingType.Summarization) {
  <xrx-summarization [setting]="setting"
                     [label]="setting.label"
                     [value]="setting.value || ''"
                     [list]="setting.options"
                     (change)="setting.value=$event"
                     (validation)="validate($event)"
                     [isAutomated]="isAutomated"
                     [serviceIndex]="serviceIndex">
  </xrx-summarization>
  }
  @case (SettingType.AudioConversion) {
  <xrx-audio-convert [setting]="setting"
                     [label]="setting.label"
                     [value]="setting.value || ''"
                     [list]="setting.options"
                     (change)="setting.value=$event"
                     (validation)="validate($event)"
                     [isAutomated]="isAutomated"
                     [serviceIndex]="serviceIndex">
  </xrx-audio-convert>
  }
  @case (SettingType.Drm) {
  <xrx-drm [label]="setting.label"
           [value]="setting.value || ''"
           (change)="setting.value = $event"
           (validation)="validate($event)">
  </xrx-drm>
  }
  @case (SettingType.PdfConvert) {
  <xrx-pdf-convert [setting]="setting"
                   [list]="setting.options"
                   [value]="setting.value || ''"
                   [value2]="setting.value2 || ''"
                   [isMfd]="false"
                   (change)="setting.value = setting.selectedValue = $event"
                   (change2)="setting.value2 = setting.selectedValue2 = $event"
                   (validation)="validate($event)">
  </xrx-pdf-convert>
  }
  }
</div>
}

@if (isPrint) {
<div>
  @switch (setting.type) {
  @case (SettingType.NumberCount) {
  <xrx-incrementer [label]="setting.label || ''"
                   [initialValue]="setting.selectedValue.value ? +setting.selectedValue.value : 0"
                   [maxLength]="setting.maxlength || 100"
                   [icon]="setting.icon"
                   [isMfd]="false"
                   [isPrint]="true"
                   (valueChange)="relayQuantityChange($event)">
  </xrx-incrementer>
  }
  @case (SettingType.Select) {
  <xrx-print-settings [(param)]="setting"
                      [(selectedValue)]="setting.selectedValue"
                      (change)="setting.value = $event.value; relayChange($event)"
                      (validation)="validate($event)"
                      [label]="setting.label"
                      [showIcon]="setting.icon !== undefined || setting.name == 'language'">
  </xrx-print-settings>
  }
  }
</div>
}
